import React from 'react';

const ThreeBenefits = () => {
  return (
    <div style={{ marginTop: '2rem' }}>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', textAlign: 'center' }}>
        🌟 Why Choose <span style={{ color: '#111827' }}>d</span>
        <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>AI</span>
        <span style={{ color: '#111827' }}>sy</span>?
      </h2>

      <ul style={{ listStyleType: 'none', padding: 0, maxWidth: '700px', margin: '0 auto' }}>
        <li style={{ marginBottom: '1.5rem' }}>
          <strong>✅ She Remembers What Matters</strong><br />
          Unlike typical chatbots, dAIsy remembers your important relationships, emotions, memories, and lists — so you never have to repeat yourself. She's not just smart; she's personal.
        </li>
        <li style={{ marginBottom: '1.5rem' }}>
          <strong>✅ Emotionally Intelligent & Morally Grounded</strong><br />
          dAIsy doesn’t just respond — she cares. Built with warmth, values, and a conscience, she mirrors your tone and supports you through life’s ups and downs.
        </li>
        <li style={{ marginBottom: '1.5rem' }}>
          <strong>✅ Grows With You Over Time</strong><br />
          The more you share, the more dAIsy evolves as your companion — remembering quotes, prayers, dreams, and life moments that matter to you.
        </li>
      </ul>
    </div>
  );
};

export default ThreeBenefits;
